import React, { ComponentProps, PropsWithChildren } from 'react'
import { Col, Container, Modal, Row } from 'react-bootstrap'
import { useGlobalStore } from 'store/useGlobalStore'
import shallow from 'zustand/shallow'
import { StyledWarningModal } from './GenericMessageWarning.styled'

interface IGenericMessageWarning extends ComponentProps<typeof Modal> {}

export const DefaultNode = () => {
  const errorMessages = useGlobalStore((state) => state.errorMessages, shallow)
  return (
    <Row>
      <Col>
        <p>{errorMessages['ShowGenericMessage']}</p>
      </Col>
    </Row>
  )
}

const GenericMessageWarning = ({ children, isAlert, ...props }: PropsWithChildren<IGenericMessageWarning>) => {
  const clearError = useGlobalStore((state) => state.clearError, shallow)
  return (
    <StyledWarningModal fullscreen={true} onHide={clearError} {...props}>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container fluid>{children}</Container>
      </Modal.Body>
    </StyledWarningModal>
  )
}
export default React.memo(GenericMessageWarning)
